module.exports = __webpack_public_path__ + "static/media/quiz.466df464.svg";